import { render, staticRenderFns } from "./editDocument.vue?vue&type=template&id=4dba71c5&"
import script from "./editDocument.vue?vue&type=script&lang=js&"
export * from "./editDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports